import {
  getEndDateBasedStartAndQty,
  getOverallEndDate,
  getOverallQty,
  getQtyBasedEndStartDate,
} from './authUtils';

export const _setAuthStartDate = (state, action) => {
  state.authStartDate = action.payload;
  state.authEndDate = getEndDateBasedStartAndQty(
    state.authStartDate,
    state.dayQuantity
  );
};
export const _setDayQuantity = (state, action) => {
  state.dayQuantity = action.payload;
  state.authEndDate = getEndDateBasedStartAndQty(
    state.authStartDate,
    state.dayQuantity
  );
};
export const _setAuthEndDate = (state, action) => {
  state.authEndDate = action.payload;
};
